import { memo } from 'react';

import { FooterSocialsAndDisclaimer } from './FooterSocialsAndDisclaimer';

export * from './FooterSocialsAndDisclaimer';

export default memo(FooterSocialsAndDisclaimer);
